// import _ from 'lodash';
import * as GiftCardActions from '../actions/GiftCard';

const initialState = {
  data: [],
  categories: [],
  error: false,
  status: 200,
  error_message: '',
  loading: false
};

const shops = (state = initialState, action) => {
  switch (action.type) {
    case GiftCardActions.GET_GIFTCARD_REQUEST:
      return { ...state, loading: true };
    case GiftCardActions.GET_GIFTCARD_SUCCESS:
      return { ...state, data: action.payload, loading: false };
    case GiftCardActions.GET_GIFTCARD_FAILURE:
      return {
        ...state,
        status: action.payload,
        error: action.error,
        loading: false
      };

    case GiftCardActions.GET_CATEGORIES_REQUEST:
      return { ...state, loading: true };
    case GiftCardActions.GET_CATEGORIES_SUCCESS:
      return { ...state, categories: action.payload, loading: false };
    case GiftCardActions.GET_CATEGORIES_FAILURE:
      return {
        ...state,
        status: action.payload,
        error: action.error,
        loading: false
      };

    case GiftCardActions.ADD_GIFTCARD_REQUEST:
      return { ...state, loading: true };
    case GiftCardActions.ADD_GIFTCARD_SUCCESS:
      return {
        ...state,
        // data: [...action.payload, ...state.data],
        loading: false
      };
    case GiftCardActions.ADD_GIFTCARD_FAILURE:
      return {
        ...state,
        status: action.payload,
        error: action.error,
        loading: false
      };

    case GiftCardActions.EDIT_GIFTCARD_REQUEST:
      return { ...state, loading: true };
    case GiftCardActions.EDIT_GIFTCARD_SUCCESS:
      return {
        ...state,
        // data: _.reduce(
        //   state.data,
        //   (res, el) => {
        //     if (el.id === action.payload.id) {
        //       res.push(action.payload);
        //     } else {
        //       res.push(el);
        //     }
        //     return res;
        //   },
        //   []
        // ),
        loading: false
      };

    case GiftCardActions.EDIT_GIFTCARD_FAILURE:
      return {
        ...state,
        status: action.payload,
        error: action.error,
        loading: false
      };

    case GiftCardActions.ORDER_GIFTCARD_REQUEST:
      return { ...state, loading: true };
    case GiftCardActions.ORDER_GIFTCARD_SUCCESS:
      return {
        ...state,
        // data: [...action.payload, ...state.data],
        loading: false
      };
    case GiftCardActions.ORDER_GIFTCARD_FAILURE:
      return {
        ...state,
        status: action.payload,
        error: action.error,
        loading: false
      };

    case GiftCardActions.DELETE_GIFTCARD_REQUEST:
      return { ...state, loading: true };
    case GiftCardActions.DELETE_GIFTCARD_SUCCESS:
      return {
        ...state,
        // data: _.filter(state.data, el => el.id !== action.payload.id),
        loading: false
      };
    case GiftCardActions.DELETE_GIFTCARD_FAILURE:
      return {
        ...state,
        status: action.payload,
        error: action.error,
        loading: false
      };

    default:
      return state;
  }
};

export default shops;
